import * as THREE from 'three';

export type ModelDiagnostics = {
  meshes: number;
  instancedMeshes: number;
  geometries: number;
  materials: number;
  textures: number;
  triangles: number;
};

export function collectModelDiagnostics(root: THREE.Object3D): ModelDiagnostics {
  const geometries = new Set<THREE.BufferGeometry>();
  const materials = new Set<THREE.Material>();
  const textures = new Set<THREE.Texture>();
  let meshes = 0;
  let instancedMeshes = 0;
  let triangles = 0;

  root.traverse((object) => {
    if (!(object instanceof THREE.Mesh)) return;
    meshes += 1;
    if (object instanceof THREE.InstancedMesh) instancedMeshes += 1;
    geometries.add(object.geometry);

    const count = object.geometry.index?.count ?? object.geometry.attributes.position?.count ?? 0;
    triangles += Math.floor(count / 3) * (object instanceof THREE.InstancedMesh ? object.count : 1);

    const meshMaterials = Array.isArray(object.material) ? object.material : [object.material];
    for (const material of meshMaterials) {
      materials.add(material);
      for (const value of Object.values(material as unknown as Record<string, unknown>)) {
        if (value instanceof THREE.Texture) textures.add(value);
      }
    }
  });

  return {
    meshes,
    instancedMeshes,
    geometries: geometries.size,
    materials: materials.size,
    textures: textures.size,
    triangles,
  };
}
